import { defineComponent as V, useSlots as R, ref as p, computed as g, createElementBlock as i, createCommentVNode as o, openBlock as t, normalizeClass as N, createElementVNode as n, createBlock as c, resolveDynamicComponent as S, toRaw as T, toDisplayString as s, renderSlot as I, unref as d, withCtx as b, createTextVNode as k, createSlots as z } from "vue";
import { RevButton as A } from "@ds/components/Button";
import { RevButtonIcon as E } from "@ds/components/ButtonIcon";
import { RevToggle as $ } from "@ds/components/Toggle";
import U from "../../icons/generated/IconCross.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
const j = { class: "mr-12 shrink-0" }, q = { class: "flex grow flex-col gap-12 pr-12 pt-2" }, F = { class: "flex flex-col gap-8" }, G = { class: "body-2-bold" }, H = {
  key: 0,
  class: "text-static-default-low caption"
}, J = {
  key: 0,
  class: "space-y-12 pb-4"
}, K = {
  key: 0,
  class: "text-static-default-mid body-2"
}, Y = /* @__PURE__ */ V({
  name: "RevInfoBlock",
  __name: "InfoBlock",
  props: {
    icon: {},
    title: {},
    caption: { default: "" },
    variant: {},
    content: { default: "" },
    cta: { default: "" },
    dismissable: { type: Boolean, default: !1 },
    dismissLabel: { default: "" },
    toggleLabel: { default: "" },
    toggleDescription: { default: "" }
  },
  emits: ["dismiss", "toggle", "click"],
  setup(v, { emit: y }) {
    const l = v, r = y, h = R(), u = p(!1), m = p(!1), C = g(() => l.content || l.cta || l.toggleLabel || h.default), w = g(() => ({
      default: a`bg-static-default-mid`,
      info: a`bg-static-info-mid`,
      success: a`bg-static-success-mid`,
      danger: a`bg-static-danger-mid`,
      warning: a`bg-static-warning-mid`
    })[l.variant]);
    function B(e) {
      r("click", e);
    }
    function _() {
      m.value = !0, r("dismiss");
    }
    function D(e) {
      r("toggle", e);
    }
    return (e, f) => m.value ? o("", !0) : (t(), i("div", {
      key: 0,
      class: N(["text-static-default-hi rounded-lg flex w-full py-16 pl-16 pr-8", w.value]),
      "data-test": "content"
    }, [
      n("div", j, [
        (t(), c(S(T(e.icon)), {
          class: "w-24",
          "data-test": "icon"
        }))
      ]),
      n("div", q, [
        n("div", F, [
          n("p", G, s(e.title), 1),
          e.caption ? (t(), i("p", H, s(e.caption), 1)) : o("", !0)
        ]),
        C.value ? (t(), i("div", J, [
          e.content ? (t(), i("p", K, s(e.content), 1)) : o("", !0),
          I(e.$slots, "default"),
          e.cta ? (t(), c(d(A), {
            key: 1,
            size: "small",
            variant: "primary",
            onClick: B
          }, {
            default: b(() => [
              k(s(e.cta), 1)
            ]),
            _: 1
          })) : o("", !0),
          e.toggleLabel ? (t(), c(d($), {
            key: 2,
            modelValue: u.value,
            "onUpdate:modelValue": [
              f[0] || (f[0] = (L) => u.value = L),
              D
            ],
            "data-test": "toggle",
            label: e.toggleLabel
          }, z({ _: 2 }, [
            e.toggleDescription ? {
              name: "default",
              fn: b(() => [
                k(s(e.toggleDescription), 1)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["modelValue", "label"])) : o("", !0)
        ])) : o("", !0)
      ]),
      e.dismissable ? (t(), c(d(E), {
        key: 0,
        "aria-label": e.dismissLabel,
        class: "shrink-0",
        "data-test": "dismiss-button",
        icon: d(U),
        variant: "secondary",
        onClick: _
      }, null, 8, ["aria-label", "icon"])) : o("", !0)
    ], 2));
  }
});
export {
  Y as default
};
